import { EntityAdapter } from 'vue-entity-adapter'

export const adapter = new EntityAdapter((a, b) => a.name.localeCompare(b.name))

export default adapter
